import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import ocbc from "../../Assets/Projects/ocbc/ocbc.jpeg";
import pos from "../../Assets/Projects/pos/pos1.jpeg";
import ezyhr from "../../Assets/Projects/ezyhr/ezyhr1.jpeg";
import pertamedika from "../../Assets/Projects/pertamedika/pertamedika.jpeg";
import puskesmasbgr from "../../Assets/Projects/puskesmasbogor/puskesmasbogor2.jpeg";
import dokter from "../../Assets/Projects/etc/dokterapp.jpeg";
import catatanapps from "../../Assets/Projects/etc/catatanapps.jpeg";
import firebasechat from "../../Assets/Projects/etc/firebasechat.jpeg";
import movieapp from "../../Assets/Projects/etc/movieapp.jpeg";
import salamubank from "../../Assets/Projects/etc/salamubank.jpeg";
import ecommerce from "../../Assets/Projects/etc/ecommerce.jpeg";
import todoapp from "../../Assets/Projects/etc/todoapp.jpeg";
import movieapp2 from "../../Assets/Projects/etc/movieapp2.jpeg";
import ekatalog from "../../Assets/Projects/etc/ekatalogshowroom.jpeg";
import revampflashcoffe from "../../Assets/Projects/etc/revampflashcoffe.jpeg";
import ikea from "../../Assets/Projects/etc/ikea.jpeg";
import { useLanguage } from "../../context/LanguageContext";

const projects = [
  {
    title: "Masjid Sejuta Pemuda · Phase 3",
    en: "A production Flutter application modernization featuring MSPay/Xendit payment orchestration for donations, Event and Kajian registration, wallet top-ups, and Coffee Bar/POS; QRIS, Virtual Account and manual transfer flows; transaction history and payment recovery; Exam and Certification modules; family subscriptions; and a complete light/dark glassmorphism redesign.",
    id: "Modernisasi aplikasi Flutter production dengan orkestrasi pembayaran MSPay/Xendit untuk donasi, registrasi Event dan Kajian, top-up wallet, serta Coffee Bar/POS; flow QRIS, Virtual Account, dan transfer manual; riwayat serta recovery pembayaran; Modul Ujian dan Sertifikasi; family subscription; dan redesign glassmorphism light/dark secara menyeluruh.",
    tech: "Flutter • BLoC/Cubit • MSPay/Xendit • ObjectBox • Freezed",
    sourceLabel: "Production Mobile App",
    demoLabel: "Android",
    demoLink: "https://play.google.com/store/apps/details?id=com.hawnan.msp",
    iosLink:
      "https://apps.apple.com/id/app/masjid-sejuta-pemuda/id6777368076?l=id",
    coverTone: "mint",
  },
  {
    title: "IMS Mobile Application",
    en: "A production Flutter application for field operations at Yokke, covering EDC monitoring, preventive and corrective maintenance work orders, GPS-stamped photo uploads, stock opname, validation flows, and offline data synchronization.",
    id: "Aplikasi Flutter untuk operasional lapangan di Yokke yang mencakup monitoring EDC, work order preventive dan corrective maintenance, unggah foto dengan GPS, stock opname, alur validasi, serta sinkronisasi data offline.",
    tech: "Flutter • Clean Architecture • Offline-first • GPS",
    sourceLabel: "LinkedIn",
    demoLabel: "LinkedIn",
    demoLink: "https://www.linkedin.com/in/zainal-salamun-660a9598/",
    coverTone: "lime",
  },
  {
    title: "MoniMate AI Finance",
    en: "An offline-first personal finance application with hybrid AI receipt scanning using Gemini and ML Kit, multi-wallet support, smart budgets, financial health insights, recurring transactions, reports, and Google Drive sync.",
    id: "Aplikasi keuangan pribadi offline-first dengan pemindai struk AI menggunakan Gemini dan ML Kit, multi-wallet, smart budget, insight kesehatan finansial, transaksi berulang, laporan, dan sinkronisasi Google Drive.",
    tech: "Flutter • GetX • Hive • Gemini • ML Kit",
    sourceLabel: "GitHub",
    ghLink: "https://github.com/zainalsalamun/moni_mate_flutter",
    coverTone: "ocean",
  },
  {
    title: "CV Craft AI",
    en: "An AI-powered CV builder featuring CV parsing, job-description match analysis, AI-assisted summaries and bullet rewrites, nine customizable templates, real-time preview, authentication, and PDF export.",
    id: "CV builder berbasis AI dengan parsing CV, analisis kecocokan job description, pembuatan ringkasan dan penulisan ulang bullet, sembilan template, preview real-time, autentikasi, dan ekspor PDF.",
    tech: "React • TypeScript • Supabase • Gemini • Tailwind",
    sourceLabel: "GitHub",
    ghLink: "https://github.com/zainalsalamun/cv-craft-ai",
    demoLink: "https://cv-craft-ai-ten.vercel.app",
    coverTone: "violet",
  },
  {
    title: "SehatKu HMS",
    en: "A multi-role Flutter hospital management system for patients, doctors, and administrators, including appointment booking, QR check-in, queues, medical records, prescriptions, analytics, and an OpenAPI-ready backend contract.",
    id: "Sistem manajemen rumah sakit multi-role berbasis Flutter untuk pasien, dokter, dan admin, dengan booking, QR check-in, antrean, rekam medis, resep, analytics, dan kontrak backend berbasis OpenAPI.",
    tech: "Flutter • Riverpod • GoRouter • OpenAPI",
    sourceLabel: "GitHub",
    ghLink: "https://github.com/zainalsalamun/sehatku_hms_mobile",
    coverTone: "coral",
  },
  {
    title: "Mobile Sekolah",
    en: "A modular Flutter school application for students and teachers with role-specific dashboards, attendance, grades, schedules, announcements, reusable components, and GetX dependency injection.",
    id: "Aplikasi sekolah modular berbasis Flutter untuk siswa dan guru dengan dashboard sesuai role, absensi, nilai, jadwal, pengumuman, komponen reusable, dan dependency injection GetX.",
    tech: "Flutter • GetX • Modular Architecture",
    sourceLabel: "GitHub",
    ghLink: "https://github.com/zainalsalamun/mobile_sekolah_apps",
    coverTone: "sky",
  },
  {
    title: "Flutter UI Clone Showcase",
    en: "A curated Flutter showcase containing more than twenty mobile UI explorations inspired by products such as Bibit, Gojek, Livin, OVO, ShopeePay, Pintu, Traveloka, Talenta, TIX ID, and other original concepts.",
    id: "Showcase Flutter berisi lebih dari dua puluh eksplorasi UI mobile yang terinspirasi dari Bibit, Gojek, Livin, OVO, ShopeePay, Pintu, Traveloka, Talenta, TIX ID, dan berbagai konsep original.",
    tech: "Flutter • Dart • UI Engineering",
    sourceLabel: "GitHub",
    ghLink: "https://github.com/zainalsalamun/flutter_project_clone",
    coverTone: "amber",
  },
  {
    title: "KAI Access UI",
    en: "A Flutter UI exploration of the KAI Access experience, including home, promotions, profile, train search, ticket booking, seat selection, food ordering, payment, and insurance screens.",
    id: "Eksplorasi UI Flutter untuk pengalaman KAI Access yang mencakup beranda, promo, profil, pencarian kereta, pemesanan tiket, pemilihan kursi, pesan makanan, pembayaran, dan asuransi.",
    tech: "Flutter • Dart • Mobile UI",
    sourceLabel: "LinkedIn + GitHub",
    ghLink: "https://github.com/zainalsalamun/flutter-kai-access",
    demoLink: "https://www.linkedin.com/in/zainal-salamun-660a9598/",
    demoLabel: "LinkedIn",
    coverTone: "rail",
  },
  {
    title: "MyRingNet ISP Management",
    en: "A full-stack ISP operations platform for PT Ring Media Nusantara, covering customers, partners, service packages, invoices, payments, finance, documents, support tickets, POP and Radius infrastructure, usage analytics, maps, notifications, and production deployment workflows.",
    id: "Platform operasional ISP full-stack untuk PT Ring Media Nusantara yang mencakup pelanggan, mitra, paket layanan, invoice, pembayaran, keuangan, dokumen, support ticket, infrastruktur POP dan Radius, analytics penggunaan, peta, notifikasi, serta deployment production.",
    tech: "Next.js • React • Express • Prisma • PostgreSQL • Docker",
    sourceLabel: "PT Ring Media Nusantara",
    ghLabel: "Frontend",
    ghLink: "https://github.com/zainalsalamun/my-ringnet-frontend",
    secondaryGhLabel: "Backend",
    secondaryGhLink: "https://github.com/zainalsalamun/my-ringnet-backend",
    coverTone: "ringnet",
  },
  {
    title: "Ringnet Invoice Management",
    en: "A full-stack ISP billing system with customer and invoice management, payment statuses and proof uploads, finance records, dynamic payment methods, support chat tracking, JWT-protected staff access, PDF and QR generation, WhatsApp-ready billing, and production logging.",
    id: "Sistem billing ISP full-stack dengan pengelolaan pelanggan dan invoice, status serta bukti pembayaran, pencatatan keuangan, metode pembayaran dinamis, support chat tracking, akses staf berbasis JWT, PDF dan QR, tagihan siap WhatsApp, serta logging production.",
    tech: "React • MUI • Express • PostgreSQL • JWT • jsPDF",
    sourceLabel: "PT Ring Media Nusantara",
    ghLabel: "Frontend",
    ghLink: "https://github.com/zainalsalamun/invoice-web",
    secondaryGhLabel: "Backend",
    secondaryGhLink: "https://github.com/zainalsalamun/ringnet-invoice-backend",
    demoLink: "https://invoice-web-ruby.vercel.app",
    coverTone: "paper",
  },
  {
    title: "Flutter Product CRUD",
    en: "A Flutter product-management application demonstrating MVC separation, Provider state management, Dio networking and interceptors, persistent authentication, and complete CRUD integration with a Laravel API.",
    id: "Aplikasi pengelolaan produk Flutter yang mendemonstrasikan pola MVC, state management Provider, networking dan interceptor Dio, autentikasi persisten, serta integrasi CRUD lengkap dengan Laravel API.",
    tech: "Flutter • Provider • Dio • MVC • Laravel",
    sourceLabel: "GitHub",
    ghLink: "https://github.com/zainalsalamun/flutter_dio_provider",
    coverTone: "mint",
  },
  {
    title: "OCBC Nyala Bisnis",
    imgPath: ocbc,
    en: "A Flutter merchant application developed for OCBC NISP and Yokke. The product helps micro and small businesses accept static QRIS payments and manage daily merchant operations.",
    id: "Aplikasi merchant berbasis Flutter untuk OCBC NISP dan Yokke. Produk ini membantu usaha mikro dan kecil menerima pembayaran QRIS statis serta mengelola operasional harian.",
  },
  {
    title: "Point of Sale",
    imgPath: pos,
    en: "A mobile point-of-sale application for managing products, inventory, customers, transactions, and business reports through one streamlined workflow.",
    id: "Aplikasi point of sale untuk mengelola produk, stok, pelanggan, transaksi, dan laporan bisnis dalam satu alur kerja yang ringkas.",
  },
  {
    title: "EzyHR Attendance",
    imgPath: ezyhr,
    en: "An employee attendance product with workforce, leave, overtime, and reporting features designed to make HR operations faster and more accurate.",
    id: "Produk absensi karyawan dengan fitur pengelolaan tenaga kerja, cuti, lembur, dan laporan untuk membuat operasional HR lebih cepat dan akurat.",
  },
  {
    title: "Pertamedika Apps",
    imgPath: pertamedika,
    en: "A patient application for outpatient reservations, doctor schedules, reservation history, and access to medical resume information.",
    id: "Aplikasi pasien untuk reservasi rawat jalan, jadwal dokter, riwayat reservasi, dan akses informasi resume medis.",
  },
  {
    title: "Puskesmas Bogor Apps",
    imgPath: puskesmasbgr,
    en: "A public healthcare application that lets patients schedule outpatient visits, review doctor availability, and access reservation and medical information.",
    id: "Aplikasi layanan kesehatan publik untuk membuat reservasi rawat jalan, melihat ketersediaan dokter, serta mengakses informasi reservasi dan medis.",
  },
  {
    title: "Doctor App",
    imgPath: dokter,
    en: "A companion application that helps doctors review scheduled patients and manage their available consultation schedules.",
    id: "Aplikasi pendamping yang membantu dokter melihat pasien terjadwal dan mengelola ketersediaan jadwal konsultasi.",
  },
  {
    title: "Credit Notes App",
    imgPath: catatanapps,
    en: "A native Android application built with Java for recording mobile-credit purchases and keeping lightweight transaction notes.",
    id: "Aplikasi Android native berbasis Java untuk mencatat pembelian pulsa dan menyimpan catatan transaksi sederhana.",
  },
  {
    title: "Firebase Chat",
    imgPath: firebasechat,
    en: "A real-time chat application built with native Android, Java, and Firebase Realtime Database.",
    id: "Aplikasi percakapan real-time yang dibangun dengan Android native, Java, dan Firebase Realtime Database.",
  },
  {
    title: "Android Movie App",
    imgPath: movieapp,
    en: "A native Android and Kotlin application for discovering movies and exploring detailed movie information.",
    id: "Aplikasi Android native berbasis Kotlin untuk menemukan film dan melihat informasi film secara terperinci.",
  },
  {
    title: "Salamu Bank UI",
    imgPath: salamubank,
    en: "A Flutter banking interface exploration focused on translating a modern financial product design into reusable mobile components.",
    id: "Eksplorasi antarmuka perbankan berbasis Flutter yang berfokus pada penerjemahan desain produk finansial modern menjadi komponen mobile reusable.",
    ghLink: "https://github.com/zainalsalamun/bank_salamu_master",
  },
  {
    title: "Flutter E-commerce",
    imgPath: ecommerce,
    en: "A Flutter commerce application featuring authentication, product browsing, checkout, persistence, and Provider-based state management.",
    id: "Aplikasi commerce berbasis Flutter dengan autentikasi, katalog produk, checkout, penyimpanan data, dan state management menggunakan Provider.",
    ghLink: "https://github.com/zainalsalamun/shoes_project",
  },
  {
    title: "Flutter Todo App",
    imgPath: todoapp,
    en: "A focused task-management application built with Flutter and SQLite for reliable local data persistence.",
    id: "Aplikasi pengelolaan tugas berbasis Flutter dan SQLite untuk penyimpanan data lokal yang andal.",
    ghLink: "https://github.com/zainalsalamun/flutter_todoapp",
  },
  {
    title: "Flutter Movie App",
    imgPath: movieapp2,
    en: "A cross-platform movie discovery interface built with Flutter and Dart.",
    id: "Antarmuka pencarian film lintas platform yang dibangun menggunakan Flutter dan Dart.",
    ghLink: "https://github.com/zainalsalamun/movie_app_screen",
  },
  {
    title: "E-catalog Showroom",
    imgPath: ekatalog,
    en: "A product presentation created with the Flutter User Group Indonesia community, covering the concept and development of a mobile showroom catalog.",
    id: "Presentasi produk hasil kolaborasi dengan komunitas Flutter User Group Indonesia yang membahas konsep dan pengembangan katalog showroom mobile.",
    demoLink:
      "https://media.licdn.com/dms/document/media/D561FAQHTzgvWk7r3Dw/feedshare-document-pdf-analyzed/0/1697457662114?e=1717027200&v=beta&t=CLphrD_rD2qzpcVmOWCnBnt2WmcIdIG1ywosICNVgqI",
  },
  {
    title: "Flash Coffee Redesign",
    imgPath: revampflashcoffe,
    en: "A product-management case study from Binar Academy, created in collaboration with a UI/UX team to rethink the Flash Coffee mobile experience.",
    id: "Studi kasus product management dari Binar Academy yang dibuat bersama tim UI/UX untuk merancang ulang pengalaman mobile Flash Coffee.",
    demoLink: "https://www.behance.net/gallery/166689967/Revamp-Flash-Coffee-App-2023",
  },
  {
    title: "IKEA Store Redesign",
    imgPath: ikea,
    en: "A full-stack e-commerce capstone built with React, Node.js, Express, and PostgreSQL as part of the Binar Academy program.",
    id: "Proyek akhir e-commerce full-stack yang dibangun dengan React, Node.js, Express, dan PostgreSQL dalam program Binar Academy.",
    demoLink: "https://binar-platinum-frontend.vercel.app",
    ghLink: "https://github.com/zainalsalamun/binar-platinum-frontend",
  },
];

function Projects() {
  const { language, t } = useLanguage();

  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          {t("projects.title")}{" "}
          <strong className="purple">{t("projects.emphasis")}</strong>
        </h1>
        <p>{t("projects.subtitle")}</p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          {projects.map((project) => (
            <Col md={4} className="project-card" key={project.title}>
              <ProjectCard
                imgPath={project.imgPath}
                title={project.title}
                description={project[language]}
                tech={project.tech}
                sourceLabel={project.sourceLabel}
                demoLabel={project.demoLabel}
                coverTone={project.coverTone}
                ghLink={project.ghLink}
                ghLabel={project.ghLabel}
                secondaryGhLink={project.secondaryGhLink}
                secondaryGhLabel={project.secondaryGhLabel}
                demoLink={project.demoLink}
                iosLink={project.iosLink}
              />
            </Col>
          ))}
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
